import { render, staticRenderFns } from "./ListSubheader.vue?vue&type=template&id=10972594&scoped=true&"
import script from "./ListSubheader.vue?vue&type=script&lang=js&"
export * from "./ListSubheader.vue?vue&type=script&lang=js&"
import style0 from "./ListSubheader.vue?vue&type=style&index=0&id=10972594&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10972594",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VSubheader})
